import { Info } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TcpaCompliance() {
  return <section id="tcpacompliance" className="bg-background py-12 px-4 md:px-6">
      <div className="mx-auto max-w-4xl rounded-lg border border-border bg-muted/20 p-6 text-sm text-muted-foreground shadow-sm md:p-8">
        <div className="mb-4 flex items-center gap-2 text-foreground">
          <Info className="size-5 text-primary shrink-0" />
          <h2 className="font-default text-base font-semibold tracking-tight">
            TCPA Disclosure & Consent
          </h2>
        </div>
        
        <div className="space-y-4 leading-relaxed">
          <p>
            By providing your phone number and submitting your information, you expressly consent to receive marketing and informational communications from <strong>Family Legacy Planning</strong>. These communications may include phone calls, text messages (SMS), and emails regarding insurance quotes, policy updates, and related services.
          </p>
          
          <p>
            You acknowledge that these communications may be generated using an automated telephone dialing system or pre-recorded voice messages. Your consent to receive these communications is not a condition of purchasing any property, goods, or services from Family Legacy Planning.
          </p>
          
          <div className="rounded-md bg-background/50 p-4 border border-border/50">
            <ul className="space-y-2">
              <li className="flex gap-2">
                <span className="font-semibold text-foreground shrink-0">Opt-Out:</span>
                <span>You may opt-out of receiving text messages at any time by replying <strong>"STOP"</strong> to any message you receive.</span>
              </li>
              <li className="flex gap-2">
                <span className="font-semibold text-foreground shrink-0">Help:</span>
                <span>For assistance, reply <strong>"HELP"</strong> to any text message.</span>
              </li>
              <li className="flex gap-2">
                <span className="font-semibold text-foreground shrink-0">Frequency:</span>
                <span>Message frequency varies based on your interactions and quote status.</span>
              </li>
              <li className="flex gap-2">
                <span className="font-semibold text-foreground shrink-0">Rates:</span>
                <span>Standard message and data rates may apply depending on your mobile carrier plan.</span>
              </li>
            </ul>
          </div>
          
          <p className="pt-2 text-xs">
            For more detailed information on how we handle your data, please review our{" "}
            <Link to="#" className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link to="#" className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors">
              Terms of Service
            </Link>.
          </p>
        </div>
      </div>
    </section>;
}